import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import WarenCodes from './WarenCodes';

export default function ControllableStates(props) {
    const [selectedCode, setSelectedCode] = useState(null);

    return (
      <Autocomplete
        id="nba teams"
        options={WarenCodes}
        renderInput={params => (
          <TextField {...params} label="Code gemäß Anhang VII Verordung (EG) Nr. 865/2006"  />
        )}
        getOptionLabel={option => option.label}
        style={{ width: '100%' }}
        value={selectedCode}
        onChange={
            (_event, newCode) => {
                setSelectedCode(newCode);
                if (newCode) {
                  props.updaterValue(newCode.code)  
                } else {
                  props.updaterValue('')
                }
                
            }
        }
      />
    );
}